import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import "./index.css";

import AppLogo from "../../assets/images/logo.png";

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light">
                <Link className="navbar-brand" to="/" onClick={closeMenu}>
                    <img src={AppLogo} alt="Defiguard" />
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    aria-controls="navbarSupportedContent"
                    aria-expanded={menuOpen}
                    aria-label="Toggle navigation"
                    onClick={() => setMenuOpen((open) => !open)}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div
                    className={`collapse navbar-collapse${menuOpen ? " show" : ""}`}
                    id="navbarSupportedContent"
                >
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/" end onClick={closeMenu}>
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/services" onClick={closeMenu}>
                                Services
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/about" onClick={closeMenu}>
                                About
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/features" onClick={closeMenu}>
                                Features
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/team" onClick={closeMenu}>
                                Team
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/blog" onClick={closeMenu}>
                                Blog
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/contact" onClick={closeMenu}>
                                Contact
                            </NavLink>
                        </li>
                    </ul>
                    <form className="form-inline my-2 my-lg-0" onSubmit={(e) => e.preventDefault()}>
                        <div className="search_bt">
                            <button type="button" aria-label="Search">
                                <i className="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </nav>
        </div>
    );
}

export default Header;
